/** Label registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseLabel } from './parser';
const labelRegistration = {
    typeName: 'Label',
    parser: parseLabel,
};
nodeRegistry.register(labelRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map